export function handleAccordionClick(parent_id, element) {
	var accordion = document.getElementById(parent_id);
	if (!accordion) return;
	var accordion_items = document.getElementsByClassName('accordion-item');
	for (var i=0;accordion_items[i]; i++ ) {
		accordion_items[i].classList.remove('is-active');
	}
	element.parentNode.classList.add('is-active');
}

// If the toggle receives focus and is not toggled to 'is-open' after 300ms,
// then focus was not from a user's click, so this will tigger the 'is-open' toggle
export function onfocusToggleExpandsetOpen(element) {
	if(!element.classList.contains('is-open')) {
		setTimeout(()=>{
			if(!element.classList.contains('is-open')) {
				element.click();
			}
		}, 500);
	}
}

export function bentoGridShowMore(id) {
	const bentoGrid = document.getElementById(id);
	const showMoreEls = bentoGrid.querySelectorAll('.show-more--desktop, .show-more--mobile');
	if(showMoreEls[0].classList.contains('is-open')) {
		showMoreEls.forEach(showMoreEl => { // close
			showMoreEl.classList.toggle('is-closing');
		});

		setTimeout(()=>{
			showMoreEls.forEach(showMoreEl => {
				showMoreEl.classList.toggle('is-open');
				showMoreEl.classList.remove('is-closing');
			});
		}, 500);
	}
	else { // open
		showMoreEls.forEach(showMoreEl => {
			showMoreEl.classList.toggle('is-opening');
		});

		setTimeout(()=>{
			showMoreEls.forEach(showMoreEl => {
				showMoreEl.classList.toggle('is-open');
				showMoreEl.classList.remove('is-opening');
			});
		}, 100);
	}

}